
import React from 'react';

export const BasicConfigTab = () => {
  return (
    <div className="space-y-4">
      <p className="text-muted-foreground">
        Configure basic application deployment settings.
      </p>
      
      <div className="p-4 bg-warning/10 border border-warning/20 rounded text-sm text-warning">
        Application basic configuration settings will be implemented in a future update.
      </div>
    </div>
  );
};
